import React from 'react';

type BitTableProps = {
	tableData: {
		headers: string[];
		data: any[];
	};
	noneMessage: string;
};

const BitTable: React.FC<BitTableProps> = ({ tableData, noneMessage }) => {
	return (
		<div className="w-full table-container tabela-customizada-container overflow-x-auto">
			<table className="table tabela-customizada w-full table-fixed">
				<thead>
					<tr>
						{tableData?.headers?.map((header, idx) => {
							const headerLower = (header || '').toString().toLowerCase();
							const isLongText =
								headerLower.includes('mensagem') ||
								headerLower.includes('descriç') ||
								headerLower.includes('texto') ||
								headerLower.includes('conteúdo');

							return (
								<th
									key={`header-${idx}`}
									className={`p-3 text-left font-semibold text-gray-700 bg-gray-50 border-b border-gray-200 ${
										isLongText ? 'w-2/5' : ''
									}`}
									style={{
										wordBreak: 'break-word',
										overflowWrap: 'anywhere',
									}}
								>
									{header}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{tableData && tableData?.data && tableData?.data.length > 0 ? (
						tableData.data.map((row, rowIdx) => {
							const actualRow: any[] = [];

							if (row && typeof row === 'object') {
								Object.keys(row).forEach(rowItem => {
									actualRow.push(row[rowItem]);
								});
							} else {
								actualRow.push(row);
							}

							return (
								<tr
									key={`row-${rowIdx}`}
									className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
								>
									{actualRow?.map((item, colIdx) => {
										const headerName = (tableData?.headers?.[colIdx] || '').toString().toLowerCase();
										const isLongText =
											headerName.includes('mensagem') ||
											headerName.includes('descriç') ||
											headerName.includes('texto') ||
											headerName.includes('conteúdo');

										return (
											<td
												key={`cell-${rowIdx}-${colIdx}`}
												className={`p-3 align-top text-sm text-gray-700 break-words whitespace-pre-line overflow-hidden ${
													isLongText ? 'max-w-md font-normal' : ''
												}`}
												style={{
													wordBreak: 'break-word',
													overflowWrap: 'anywhere',
												}}
											>
												{item}
											</td>
										);
									})}
								</tr>
							);
						})
					) : (
						<tr>
							<td
								colSpan={tableData?.headers?.length || 1}
								className="text-center p-6 text-gray-500 italic"
							>
								{noneMessage}
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

export default BitTable;
